import { useState, useEffect } from 'react';

export function useIsKeyboardOpen() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
  const isMobile = window.matchMedia('(pointer: coarse)').matches;
  if (!isMobile) return;

  const vv = window.visualViewport;
  if (!vv) return;

  const handleResize = () => {
    const ratio = vv.height / window.innerHeight;
    setIsOpen(ratio < 0.75); // keyboard covers >25% of layout viewport
  };

  vv.addEventListener('resize', handleResize);
  document.addEventListener('focusin', handleResize);
  document.addEventListener('focusout', handleResize);

  return () => {
    vv.removeEventListener('resize', handleResize);
    document.removeEventListener('focusin', handleResize);
    document.removeEventListener('focusout', handleResize);
  };
}, []);

  return isOpen;
}
